import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { PageHeader } from "@/components/ui-bits";
import { useLang } from "@/lib/i18n";

export const WachtwoordVergeten = () => {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-28 pb-16">
      <div className="w-full max-w-md">
        <PageHeader eyebrow={t("auth.forgotEyebrow")} title={<>Wachtwoord <span className="italic normal-case text-gold">{t("auth.forgotTitle2")}</span></>} />
        {sent ? (
          <div data-testid="forgot-success" className="border border-gold/20 bg-ink p-8">
            <p className="text-sm text-cream leading-relaxed">
              {t("auth.forgotOk")}
            </p>
          </div>
        ) : (
          <form data-testid="forgot-form" onSubmit={submit} className="border border-gold/15 bg-ink p-8 space-y-5">
            <label className="block">
              <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-smoke block mb-2">{t("auth.yourEmail")}</span>
              <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-obsidian border border-gold/15 px-4 py-3.5 text-sm text-cream focus:outline-none focus:border-gold/50" />
            </label>
            {error && <p data-testid="forgot-error" className="text-xs text-red-400">{error}</p>}
            <button type="submit" data-testid="forgot-submit-button" disabled={busy} className="w-full bg-gold text-obsidian font-mono text-[11px] tracking-[0.3em] uppercase py-4 hover:bg-gold-light disabled:opacity-40 transition-colors">
              {busy ? t("auth.sending") : t("auth.forgotBtn")}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default WachtwoordVergeten;
